import { createSlice } from "@reduxjs/toolkit";
import { getCouponActionLogs, getCouponList } from "./thunk";

export interface IState {
  lstCoupon: any;
  isCouponLoading: boolean;
  isCouponSuccess: boolean;

  lstCouponActionLog: any,
  isCouponActionLogLoading: boolean,
  isCouponActionLogSuccess: boolean,

  error: any;
}

export const initialState: IState = {
  lstCoupon: null,
  isCouponLoading: false,
  isCouponSuccess: false,

  lstCouponActionLog: null,
  isCouponActionLogLoading: false,
  isCouponActionLogSuccess: false,

  error: {},
};

const CouponSlice = createSlice({
  name: "Coupon",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Coupon
    builder.addCase(getCouponList.pending, (state: IState, action: any) => {
      state.isCouponLoading = true;
    });
    builder.addCase(
      getCouponList.fulfilled,
      (state: IState, action: any) => {
        state.lstCoupon = action.payload.data;
        state.isCouponSuccess = true;
        state.isCouponLoading = false;
      }
    );
    builder.addCase(
      getCouponList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isCouponSuccess = false;
        state.isCouponLoading = false;
      }
    );

    //get Coupon Action Log
    builder.addCase(getCouponActionLogs.pending, (state: IState, action: any) => {
      state.isCouponActionLogLoading = true;
    });
    builder.addCase(
      getCouponActionLogs.fulfilled,
      (state: IState, action: any) => {
        state.lstCouponActionLog = action.payload.data;
        state.isCouponActionLogSuccess = true;
        state.isCouponActionLogLoading = false;
      }
    );
    builder.addCase(
      getCouponActionLogs.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isCouponActionLogSuccess = false;
        state.isCouponActionLogLoading = false;
      }
    );
  },
});

export default CouponSlice.reducer;